import { AppAreaConfig } from '@/funnels/@types'
import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-yoga',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-yoga-f', 'age-yoga-f'],
		route: {
			path: '/yoga-f',
			name: 'female-yoga-funnel',
		},
	},
	funnel: {
		id: 'ob-female-activity-chair-yoga',
		route: {
			path: '/yoga-f/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-chair-yoga',
		},
		// @ts-expect-error - Legacy: slug не совпадает с appArea, будет исправлено позже
		slug: 'female-activity-yoga',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-yoga-f',
		overrides: [
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-yoga-f-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-yoga-f'],
	},
}

export default appAreaConfig
